import * as React from 'react';

import './NoSlotsAvailable.pcss';

interface Props {
  uiWordSlot:string;
}

export const NoSlotsAvailable = (props:Props) =>
  <div className={"no-slots-available"}>
    <p>There are currently no available {props.uiWordSlot.toLowerCase()}s.</p>
  </div>
;